
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../../app.config';

@Injectable()
export class DeclarationsValidationService {
    private urlTonnageTotale: string = '';
    private urlPeTonnage: string = '';
    private urlGetTonnagetotalTraite: string = '';
    private urlGetRepartionTonnage: string = '';
    private urlGetErrors: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlTonnageTotale = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetTonnageTotal?idDett=';
        this.urlPeTonnage = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetDeclarationPeTonnage?idDett=';
        this.urlGetTonnagetotalTraite = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetTonnageTotalTraite?idDett=';
        this.urlGetRepartionTonnage = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetRepartitionTonnages?idDett=';
        this.urlGetErrors = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetErreurs?idDett=';
    }

    getErrors(idDett): Observable<any> {
        return this.http.get(this.urlGetErrors + idDett)
        .map(this.formatErrors)
            .catch(this.handleError);
    }
    private formatErrors(errors) {
        errors = errors || [];
        const filtretErrors = errors.reduce((acc, currentItem) => {
            if (currentItem.bloquant) {
                acc.bloquants.push(currentItem);
            } else {
                acc.alerts.push(currentItem);
            }
            return acc;
        }, {bloquants: [], alerts: []});


        const bloquantsObjects = filtretErrors.bloquants.reduce((acc, currentItem) => {
            if (!acc[currentItem.etape]) {
                acc[currentItem.etape] = [currentItem.message];
            } else {
                acc[currentItem.etape].push(currentItem.message);
            }
            return acc;
        }, {});

        const alertsObjects = filtretErrors.alerts.reduce((acc, currentItem) => {
            if (!acc[currentItem.etape]) {
                acc[currentItem.etape] = [currentItem.message];
            } else {
                acc[currentItem.etape].push(currentItem.message);
            }
            return acc;
        }, {});

        const bloquantsArray = [];
        Object.keys(bloquantsObjects).forEach(etape => {
            bloquantsArray.push({etape: etape, messages : bloquantsObjects[etape]});
        });

        const alertsArray = [];
        Object.keys(alertsObjects).forEach(etape => {
            alertsArray.push({etape: etape, messages : alertsObjects[etape]});
        });

        return {bloqants: bloquantsArray, alerts: alertsArray };
    }


    getTonnageTotale(idDett): Observable<any> {
        return this.http.get(this.urlTonnageTotale + idDett)
            .catch(this.handleError);
    }

    getPeTonnage(idDett): Observable<any> {
        return this.http.get(this.urlPeTonnage + idDett)
            .catch(this.handleError);
    }

    getTonnagetotalTraite(idDett): Observable<any> {
        return this.http.get(this.urlGetTonnagetotalTraite + idDett)
            .catch(this.handleError);
    }

    getRepartionTonnage(idDett): Observable<any> {
        return this.http.get(this.urlGetRepartionTonnage + idDett)
            .catch(this.handleError);
    }

    getTotalsRepartionTonnages(repartionTonnages) {
        return repartionTonnages.reduce((acc, item) => {
            acc.tonnageOm = acc.tonnageOm + (isNaN(parseFloat(item.tonnageOm)) ? 0 : parseFloat(item.tonnageOm));
            acc.partOm = acc.partOm + (isNaN(parseFloat(item.partOm)) ? 0 : parseFloat(item.partOm));

            acc.partAcierMach = acc.partAcierMach + (isNaN(parseFloat(item.partAcierMach)) ? 0 : parseFloat(item.partAcierMach));
            acc.partAluMach = acc.partAluMach + (isNaN(parseFloat(item.partAluMach)) ? 0 : parseFloat(item.partAluMach));

            acc.partAcierCs = acc.partAcierCs + (isNaN(parseFloat(item.partAcierCs)) ? 0 : parseFloat(item.partAcierCs));
            acc.partAluCs = acc.partAluCs + (isNaN(parseFloat(item.partAluCs)) ? 0 : parseFloat(item.partAluCs));

            return acc;
        }, { tonnageOm: 0, partOm: 0, partAcierMach: 0, partAluMach: 0, partAcierCs: 0, partAluCs: 0 });
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations-validation.service.ts